export const ROLES = [
  "Marketing Manager", "Performance Marketer", "SEO Executive", "Content Creator",
  "PR Manager", "Social Media Manager", "Influencer Manager",
  "Videographer", "Video Editor", "Content Writer", "Graphic Designer",
];

// options: array OR "$settingsKey" string resolved from settings
export const TRACKERS = {
  "pr-coverage": {
    title: "Media & News Coverage",
    endpoint: "pr-coverage",
    columns: [
      { key: "date", label: "Date", type: "date" },
      { key: "publication", label: "Publication/Outlet", type: "text" },
      { key: "coverage_type", label: "Type", type: "select", options: ["News Article", "Feature", "Mention"] },
      { key: "topic", label: "Topic", type: "text" },
      { key: "reach", label: "Reach", type: "number" },
      { key: "link", label: "Link", type: "link" },
      { key: "sentiment", label: "Sentiment", type: "select", options: ["Positive", "Neutral", "Negative"] },
      { key: "status", label: "Status", type: "select", options: ["Pitched", "Confirmed", "Published"] },
    ],
  },
  "pr-awards": {
    title: "Awards Tracker",
    endpoint: "pr-awards",
    columns: [
      { key: "award_name", label: "Award Name", type: "text" },
      { key: "awarding_body", label: "Awarding Body", type: "text" },
      { key: "category", label: "Category", type: "text" },
      { key: "deadline", label: "Deadline", type: "date" },
      { key: "status", label: "Status", type: "select", options: ["Researching", "Applied", "Shortlisted", "Won", "Not Won"] },
      { key: "submission_date", label: "Submitted", type: "date" },
      { key: "result_date", label: "Result", type: "date" },
      { key: "notes", label: "Notes", type: "text" },
    ],
  },
  "pr-appearances": {
    title: "Appearances & Interviews",
    endpoint: "pr-appearances",
    columns: [
      { key: "date", label: "Date", type: "date" },
      { key: "type", label: "Type", type: "select", options: ["Podcast", "Interview", "Public Event"] },
      { key: "platform", label: "Platform", type: "text" },
      { key: "featuring", label: "Featuring", type: "text" },
      { key: "topic", label: "Topic", type: "text" },
      { key: "reach", label: "Reach", type: "number" },
      { key: "link", label: "Link", type: "link" },
      { key: "sentiment_notes", label: "Sentiment Notes", type: "text" },
    ],
  },
  "social-posts": {
    title: "Daily Posting Log",
    endpoint: "social-posts",
    columns: [
      { key: "date", label: "Date", type: "date" },
      { key: "platform", label: "Platform", type: "select", options: "$platforms" },
      { key: "post_type", label: "Post Type", type: "text" },
      { key: "content_topic", label: "Topic", type: "text" },
      { key: "posted", label: "Posted", type: "select", options: ["Y", "N"] },
      { key: "views", label: "Views", type: "number" },
      { key: "likes", label: "Likes", type: "number" },
      { key: "comments", label: "Comments", type: "number" },
      { key: "shares", label: "Shares", type: "number" },
      { key: "link", label: "Link", type: "link" },
    ],
  },
  "social-growth": {
    title: "Platform Growth Tracker",
    endpoint: "social-growth",
    columns: [
      { key: "date", label: "Date", type: "date" },
      { key: "platform", label: "Platform", type: "select", options: "$platforms" },
      { key: "follower_count", label: "Follower Count", type: "number" },
    ],
  },
  "influencers": {
    title: "Influencer Database",
    endpoint: "influencers",
    columns: [
      { key: "name", label: "Name", type: "text" },
      { key: "platform", label: "Platform", type: "text" },
      { key: "follower_count", label: "Followers", type: "number" },
      { key: "niche", label: "Niche", type: "text" },
      { key: "contact", label: "Contact", type: "text" },
      { key: "rate_card", label: "Rate Card (₹)", type: "number" },
      { key: "status", label: "Status", type: "select", options: ["Prospecting", "Negotiating", "Onboarded", "Inactive"] },
    ],
  },
  "campaigns": {
    title: "Campaign Tracker",
    endpoint: "campaigns",
    columns: [
      { key: "campaign_name", label: "Campaign", type: "text" },
      { key: "influencers", label: "Influencer(s)", type: "text" },
      { key: "brief_given", label: "Brief", type: "select", options: ["Y", "N"] },
      { key: "deliverable_type", label: "Deliverable", type: "text" },
      { key: "deadline", label: "Deadline", type: "date" },
      { key: "delivery_status", label: "Delivery", type: "select", options: ["Pending", "Delivered", "Late"] },
      { key: "content_link", label: "Link", type: "link" },
      { key: "spend", label: "Spend (₹)", type: "number" },
      { key: "reach", label: "Reach", type: "number" },
      { key: "conversions", label: "Conversions", type: "number" },
      { key: "return_value", label: "Return (₹)", type: "number" },
    ],
  },
  "shoots": {
    title: "Shoot Log",
    endpoint: "shoots",
    columns: [
      { key: "date", label: "Date", type: "date" },
      { key: "videographer", label: "Videographer", type: "text" },
      { key: "shoot_type", label: "Type", type: "select", options: ["Testimonial", "Procedure B-roll", "Ad", "Interview", "Event", "Reel"] },
      { key: "content_shot", label: "Content Shot", type: "text" },
      { key: "location", label: "Location/Branch", type: "text" },
      { key: "equipment", label: "Equipment", type: "text" },
      { key: "lighting_quality", label: "Lighting (1-5)", type: "number" },
      { key: "framing_quality", label: "Framing (1-5)", type: "number" },
      { key: "handed_to_editor", label: "To Editor", type: "select", options: ["Y", "N"] },
    ],
  },
  "edits": {
    title: "Editing Log",
    endpoint: "edits",
    columns: [
      { key: "date", label: "Date", type: "date" },
      { key: "editor", label: "Editor", type: "text" },
      { key: "linked_shoot", label: "Linked Shoot", type: "text" },
      { key: "video_type", label: "Video Type", type: "text" },
      { key: "hook_rating", label: "Hook (1-5)", type: "number" },
      { key: "retention", label: "Retention %", type: "number" },
      { key: "status", label: "Status", type: "select", options: ["Editing", "Review", "Approved", "Published"] },
      { key: "time_spent", label: "Time Spent", type: "text" },
      { key: "published_link", label: "Link", type: "link" },
      { key: "notes", label: "Notes", type: "text" },
    ],
  },
  "content-writing": {
    title: "Content Writing Tracker",
    endpoint: "content-writing",
    columns: [
      { key: "date", label: "Date", type: "date" },
      { key: "writer", label: "Writer", type: "text" },
      { key: "content_type", label: "Content Type", type: "select", options: "$content_types" },
      { key: "platform", label: "Platform/Purpose", type: "select", options: "$platforms" },
      { key: "linked_campaign", label: "Linked Campaign", type: "text" },
      { key: "status", label: "Status", type: "select", options: ["Draft", "Review", "Approved", "Published"] },
      { key: "strategy_aligned", label: "Strategy Aligned", type: "select", options: ["Y", "N"] },
      { key: "performance", label: "Performance", type: "text" },
      { key: "remarks", label: "Remarks", type: "text" },
    ],
  },
  "graphic-design": {
    title: "Graphic Design Tracker",
    endpoint: "graphic-design",
    columns: [
      { key: "date", label: "Date", type: "date" },
      { key: "designer", label: "Designer", type: "text" },
      { key: "design_type", label: "Design Type", type: "select", options: "$design_types" },
      { key: "audience_segment", label: "Audience", type: "select", options: "$audience_segments" },
      { key: "purpose", label: "Purpose", type: "text" },
      { key: "status", label: "Status", type: "select", options: ["Draft", "Review", "Approved", "Published"] },
      { key: "revisions", label: "Revisions", type: "number" },
      { key: "time_spent", label: "Time Spent", type: "text" },
      { key: "approved", label: "Approved", type: "select", options: ["Y", "N"] },
    ],
  },
  "business-performance": {
    title: "Business Performance (monthly)",
    endpoint: "business-performance",
    columns: [
      { key: "business", label: "Business", type: "select", options: "$businesses" },
      { key: "month", label: "Month (YYYY-MM)", type: "text" },
      { key: "target", label: "Target (₹)", type: "number" },
      { key: "actual", label: "Actual (₹)", type: "number" },
      { key: "leads", label: "Leads", type: "number" },
      { key: "qualified_leads", label: "Qualified Leads", type: "number" },
      { key: "consultations", label: "Consultations", type: "number" },
      { key: "revenue", label: "Revenue (₹)", type: "number" },
      { key: "spend", label: "Spend (₹)", type: "number" },
      { key: "reach", label: "Reach", type: "number" },
    ],
  },
  "branch-performance": {
    title: "Branch Performance (monthly)",
    endpoint: "branch-performance",
    columns: [
      { key: "branch", label: "Branch", type: "select", options: "$branches" },
      { key: "month", label: "Month (YYYY-MM)", type: "text" },
      { key: "leads", label: "Leads", type: "number" },
      { key: "qualified_leads", label: "Qualified Leads", type: "number" },
      { key: "consultations", label: "Consultations", type: "number" },
      { key: "revenue", label: "Revenue (₹)", type: "number" },
      { key: "spend", label: "Spend (₹)", type: "number" },
      { key: "reach", label: "Reach", type: "number" },
    ],
  },
  "competitors": {
    title: "Competitors We Follow",
    endpoint: "competitors",
    columns: [
      { key: "name", label: "Competitor Name", type: "text" },
      { key: "category", label: "Category / Business", type: "select", options: "$businesses" },
      { key: "location", label: "Location", type: "text" },
      { key: "link", label: "Website / Social", type: "link" },
      { key: "platforms", label: "Platforms We Follow", type: "text" },
      { key: "date_added", label: "Date Added", type: "date" },
      { key: "status", label: "Status", type: "select", options: ["Active", "Inactive"] },
      { key: "last_checked", label: "Last Checked", type: "date" },
      { key: "latest_observation", label: "Latest Observation", type: "text" },
    ],
  },
  "competitor-rnd": {
    title: "Competitor R&D",
    endpoint: "competitor-rnd",
    columns: [
      { key: "date", label: "Date", type: "date" },
      { key: "competitor", label: "Competitor", type: "text" },
      { key: "observed", label: "What was observed", type: "text" },
      { key: "service_product", label: "Service/Product", type: "text" },
      { key: "offer_campaign", label: "Offer/Campaign", type: "text" },
      { key: "platform_source", label: "Platform/Source", type: "text" },
      { key: "key_insight", label: "Key Insight", type: "text" },
      { key: "action_required", label: "Action Required", type: "text" },
      { key: "owner", label: "Owner", type: "text" },
      { key: "deadline", label: "Deadline", type: "date" },
      { key: "status", label: "Status", type: "select", options: ["Open", "In Progress", "Completed"] },
      { key: "proof_link", label: "Proof/Link", type: "link" },
    ],
  },
  "manager-actions": {
    title: "Manager Action Tracker",
    endpoint: "manager-actions",
    columns: [
      { key: "date", label: "Date", type: "date" },
      { key: "problem", label: "Problem / Insight", type: "text" },
      { key: "action", label: "Action", type: "text" },
      { key: "owner", label: "Owner", type: "text" },
      { key: "deadline", label: "Deadline", type: "date" },
      { key: "status", label: "Status", type: "select", options: ["Open", "In Progress", "Completed"] },
      { key: "result", label: "Result", type: "text" },
      { key: "category", label: "Category", type: "select", options: ["Business", "Branch", "Team", "Competitor", "Campaign", "Content", "SEO", "Audience"] },
    ],
  },
  "kpi-configs": {
    title: "KPIs",
    endpoint: "kpi-configs",
    columns: [
      { key: "name", label: "KPI Name", type: "text" },
      { key: "role", label: "Role", type: "select", options: "$roles" },
      { key: "metric_key", label: "Metric Key", type: "text" },
      { key: "module", label: "Module", type: "text" },
      { key: "unit", label: "Unit", type: "text" },
      { key: "default_target", label: "Default Target", type: "number" },
      { key: "weightage", label: "Weightage", type: "number" },
      { key: "direction", label: "Direction", type: "select", options: ["higher", "lower"] },
      { key: "active", label: "Active", type: "select", options: ["Y", "N"] },
    ],
  },
};

export const METRICS_BY_ROLE = {
  "Marketing Manager": [
    { key: "marketing_revenue", label: "Marketing Revenue" },
    { key: "total_leads", label: "Total Marketing Leads" },
    { key: "mm_qualified_leads", label: "Qualified Leads" },
    { key: "mm_consultations", label: "Consultations" },
    { key: "mm_conversion", label: "Conversion %" },
    { key: "marketing_roi", label: "Marketing ROI %" },
    { key: "organic_growth", label: "Organic Growth %" },
    { key: "campaign_achievement", label: "Campaign Achievement %" },
    { key: "branch_growth", label: "Branch Marketing Growth %" },
    { key: "projects_completed", label: "Projects Completed" },
    { key: "dept_target_achievement", label: "Department Target Achievement %" },
    { key: "team_kpi_achievement", label: "Team KPI Achievement %" },
    { key: "task_completion", label: "Task Completion %" },
    { key: "ontime_execution", label: "On-Time Execution %" },
    { key: "audience_growth", label: "Audience Growth" },
    { key: "strategic_actions", label: "Strategic Actions Completed" },
  ],
  "Performance Marketer": [
    { key: "ad_spend", label: "Ad Spend" },
    { key: "pm_leads", label: "Leads" },
    { key: "pm_qualified_leads", label: "Qualified Leads" },
    { key: "cpl", label: "CPL" },
    { key: "pm_consultations", label: "Consultations" },
    { key: "pm_conversion", label: "Conversion %" },
    { key: "pm_revenue", label: "Revenue" },
    { key: "roas", label: "ROAS" },
    { key: "pm_campaign_achievement", label: "Campaign Achievement %" },
  ],
  "SEO Executive": [
    { key: "organic_traffic", label: "Organic Traffic" },
    { key: "keyword_ranking", label: "Keyword Ranking" },
    { key: "organic_leads", label: "Organic Leads" },
    { key: "organic_consultations", label: "Organic Consultations" },
    { key: "organic_revenue", label: "Organic Revenue" },
    { key: "gbp_growth", label: "Google Profile Growth" },
    { key: "seo_tasks", label: "SEO Tasks Completed" },
    { key: "tech_issues_closed", label: "Technical Issues Closed" },
  ],
  "Content Creator": [
    { key: "content_created", label: "Content Created" },
    { key: "content_published", label: "Content Published" },
    { key: "cc_views", label: "Views" },
    { key: "cc_reach", label: "Reach" },
    { key: "cc_engagement", label: "Engagement" },
    { key: "cc_saves_shares", label: "Saves/Shares" },
    { key: "cc_approval", label: "Content Approval %" },
    { key: "cc_revision", label: "Revision %" },
    { key: "cc_leads", label: "Leads Generated" },
  ],
  "PR Manager": [
    { key: "pr_coverage", label: "Media Coverage Pieces" },
    { key: "pr_awards_won", label: "Awards Won" },
    { key: "pr_appearances", label: "Interviews/Appearances" },
  ],
  "Social Media Manager": [
    { key: "posts_published", label: "Posts Published" },
    { key: "total_views", label: "Total Views" },
    { key: "total_engagement", label: "Total Engagement" },
    { key: "follower_growth", label: "Follower Growth %" },
    { key: "viral_count", label: "Viral Content" },
  ],
  "Influencer Manager": [
    { key: "active_influencers", label: "Active Influencers" },
    { key: "campaigns_running", label: "Campaigns Running" },
    { key: "overall_roi", label: "Overall ROI %" },
  ],
  "Videographer": [
    { key: "shoots_completed", label: "Shoots Completed" },
    { key: "avg_hook_rating", label: "Avg Hook Rating" },
  ],
  "Video Editor": [
    { key: "videos_edited", label: "Videos Edited" },
    { key: "avg_hook_rating", label: "Avg Hook Rating" },
  ],
  "Content Writer": [
    { key: "cw_delivered", label: "Pieces Delivered" },
    { key: "cw_approval", label: "Approval Rate %" },
  ],
  "Graphic Designer": [
    { key: "gd_delivered", label: "Designs Delivered" },
    { key: "gd_revision_rate", label: "Avg Revisions" },
    { key: "gd_approval", label: "Approval Rate %" },
  ],
};

export const PIPELINE_STAGES = [
  "Idea/Brief", "Shoot Scheduled", "Shot", "In Edit", "Copy Written", "Design Ready", "Approved", "Published",
];
